import { ArrowRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import LocalizedLink from "./LocalizedLink";
import { CategoryImage } from "./CategoryImage";

// Six treatments from one system: image placement, crop focus and surface vary per tile.
const VARIANTS = [
  { bg: "bg-white", kind: "side", pos: "72% 42%" },
  { bg: "bg-mist", kind: "bottom", pos: "90% 30%" },
  { bg: "bg-white", kind: "corner", pos: "50% 40%" },
  { bg: "bg-ice", kind: "top", pos: "84% 50%" },
  { bg: "bg-white", kind: "side", pos: "64% 78%" },
  { bg: "bg-mist", kind: "bottom", pos: "86% 64%" },
];

// Mobile: every image sits last as a wide, short band bleeding to the tile edges.
const FRAME = {
  side: "tile-band tile-side order-last -mx-8 -mb-8 mt-8 h-[150px] sm:h-[170px] lg:absolute lg:inset-y-0 lg:end-0 lg:w-[40%] lg:h-auto lg:m-0",
  bottom: "tile-band order-last -mx-8 md:-mx-10 -mb-8 md:-mb-10 mt-8 h-[150px] sm:h-[190px]",
  corner: "tile-band tile-corner order-last -mx-8 -mb-8 mt-8 h-[150px] sm:h-[180px] lg:absolute lg:bottom-0 lg:end-0 lg:w-[66%] lg:h-[220px] lg:m-0",
  top: "tile-band tile-top order-last sm:order-first -mx-8 md:-mx-10 -mb-8 sm:mb-8 sm:-mt-8 md:-mt-10 mt-8 h-[150px] sm:h-[170px]",
};
const TEXT = { side: "lg:pe-[42%]", corner: "lg:pb-[220px]", bottom: "", top: "" };

export const CategoryTile = ({ c, i, meta, explore }) => {
  const v = VARIANTS[i % VARIANTS.length];
  return (
    <Reveal delay={(i % 3) * 0.06} className="h-full">
      <LocalizedLink
        to={`/products#${c.id}`}
        data-testid={`category-card-${c.id}`}
        className={`group relative flex flex-col overflow-hidden border-e border-b border-ice p-8 md:p-10 h-full lg:min-h-[540px] ${v.bg}`}
      >
        <div className={`${FRAME[v.kind]} overflow-hidden`}>
          <CategoryImage
            id={c.id}
            alt={c.alt}
            sizes="(min-width: 1024px) 400px, (min-width: 640px) 50vw, 100vw"
            position={v.pos}
            className="w-full h-full object-cover transition-transform duration-700 ease-out motion-safe:group-hover:scale-[1.025]"
            testid={`category-image-${c.id}`}
          />
        </div>
        <div className={`relative flex flex-col flex-1 ${TEXT[v.kind]}`}>
          <p className="font-mono text-xs font-medium tracking-[0.18em] text-pine">0{i + 1}</p>
          <h3 className="font-display text-xl md:text-[22px] font-semibold text-ink mt-6 transition-colors duration-300 group-hover:text-deep">{c.name}</h3>
          <p className="text-sm text-slate mt-3 leading-relaxed">{c.desc}</p>
          <p className="font-mono text-xs tracking-[0.12em] uppercase text-slate mt-6">{meta}</p>
          <span className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-ink">
            {explore}
            <ArrowRight size={14} className="text-pine transition-transform duration-300 motion-safe:group-hover:translate-x-1 rtl:-scale-x-100" />
          </span>
        </div>
      </LocalizedLink>
    </Reveal>
  );
};
